import { render, staticRenderFns } from "./LoadPageComponent.vue?vue&type=template&id=bb286876&scoped=true&"
import script from "./LoadPageComponent.vue?vue&type=script&lang=js&"
export * from "./LoadPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoadPageComponent.vue?vue&type=style&index=0&id=bb286876&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb286876",
  null
  
)

export default component.exports